const MAX_PROVIDER_MESSAGE_LENGTH = 300;

/* Only a same-site path is followed; anything else falls back to the app's connection page. */
const toSafeReturnPath = (value) => {
  const candidate = String(value || '').trim();
  if (!candidate.startsWith('/') || candidate.startsWith('//') || candidate.includes('\\')) {
    return '';
  }
  return candidate;
};

const toDestinationLabel = ({ path, appName }) => {
  if (path.startsWith('/threads/')) {
    return 'Back to the conversation';
  }
  if (path.startsWith('/automations')) {
    return 'Back to the automation';
  }
  if (path.startsWith(`/connections/`)) {
    return `Back to ${appName}`;
  }
  if (path === '/connections') {
    return 'Back to connections';
  }
  return 'Continue';
};

const toProviderMessage = (searchParams) => {
  const raw = searchParams.get('message') || searchParams.get('error_description') || searchParams.get('error') || '';
  const message = raw.trim();
  if (message.length <= MAX_PROVIDER_MESSAGE_LENGTH) {
    return message;
  }
  return `${message.slice(0, MAX_PROVIDER_MESSAGE_LENGTH).trimEnd()}...`;
};

/**
 * What the page a provider returns to after a sign-in shows: whether the app connected, what the
 * provider said when it did not, and where to send the person next (the page or conversation that
 * started the sign-in, as the API echoes it in `returnPath`, else the app's connection page).
 */
const resolveOauthReturn = ({ appSlug, appName, outcome, searchParams }) => {
  const isConnected = outcome === 'success';
  const fallbackPath = `/connections/${encodeURIComponent(appSlug)}`;
  const destination = toSafeReturnPath(searchParams.get('returnPath')) || fallbackPath;
  const requestedScopes = String(searchParams.get('requestedScopes') || '')
    .split(/[\s,]+/)
    .filter(Boolean);

  return {
    isConnected,
    title: isConnected ? `${appName} is connected` : `${appName} was not connected`,
    description: isConnected ? 'Pieve can now work in this app. Go back to pick up where you left off.' : 'The sign-in did not finish, so nothing was saved. Go back and start the connection again.',
    providerMessage: isConnected ? '' : toProviderMessage(searchParams),
    // `error` is the provider's own refusal; without it the message is Pieve's (an expired or reused link).
    providerMessageLabel: searchParams.get('error') ? `What ${appName} said` : 'Details',
    requestedScopes: isConnected ? [] : requestedScopes,
    destination,
    destinationLabel: toDestinationLabel({ path: destination, appName })
  };
};

export default resolveOauthReturn;
